import CardConstructor from "../components/CardConstructor";
import styled from "styled-components";
import InitialsBackground from "../components/InitialsBackground";

const ReadPage = () => {
  return (
    <Wrapper>
      <InitialsBackground />
      <CardConstructor
        centered={false}
        title={
          <span className="page-title">
            Dmitry: A Design Leader with a Strategic Mindset and an
            Entrepreneurial Spirit
          </span>
        }
        content={
          <div>
            <h6 className="page-subtitle">About Me</h6>
            <p className="page-content">
              I’m Dmitry, a design leader, strategist, and hands-on product
              designer with 17+ years of experience shaping digital products,
              scaling teams, and driving impact through data, craft, and smart
              decision-making. I thrive at the intersection of strategy,
              research, and design, balancing business goals with user needs to
              deliver high-impact solutions.
            </p>

            <p className="page-content other-paragraph">
              Beyond work, I’m a family man, a lifelong learner, and an
              enthusiast of all things well-crafted — from typography to
              sourdough bread. I believe in thoughtful, ethical design and in
              building teams that are independent, proactive, and passionate.
            </p>

            <h6 className="page-subtitle">Professional Summary</h6>
            <h6 className="page-subheading">Who I Am</h6>

            <p className="page-content other-paragraph">
              A product design leader blending strategy, craft, and data-driven
              decision-making. I scale teams, build high-quality experiences,
              and create products that balance business growth with user
              satisfaction.
            </p>

            <h6 className="page-subheading">What I Bring</h6>

            <ul className="page-content other-paragraph">
              <li>
                17+ years in product design, from hands-on execution to
                leadership.
              </li>
              <li>
                Research-driven, analytical approach — conducted moderated
                usability tests, A/B tests, and data deep dives.
              </li>
            </ul>
          </div>
        }
      />
    </Wrapper>
  );
};

export default ReadPage;

const Wrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  overflow-y: auto;
  padding-bottom: 40px;

  .page-title {
    font-weight: 700;
    font-size: 40px;
    padding: 15px 0;
  }

  .page-subtitle {
    font-size: 20px;
    font-weight: 700;
  }

  .page-content {
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    line-height: 145%;
    letter-spacing: -0.3px;
    font-variant-numeric-zero: slashed-zero;
  }

  .other-paragraph {
    padding-top: 25px;
  }

  .page-subheading {
    font-weight: 500;
  }

  .profile-pic-btn {
    text-transform: none;
    background-color: #243aff;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 20px;
    margin-top: 25px;
  }

  .profile-pic-btn > img {
    width: 24px;
    height: 24px;
    margin-right: 15px;
    letter-spacing: -0.5px;
  }

  @media screen and (max-width: 650px) {
    .page-title {
      font-size: 26px;
    }
  }
`;
